const minin = {
  data() {
    return {
      baseUrl: 'staff',
      tabIdx: 0,
      tabData: [
        {
          slot: "first",
          name: "在职",
        },
        {
          slot: "second",
          name: "离职",
        },
        {
          slot: "third",
          name: "冻结",
        },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
        /*{
          label: "性别：",
          keyName: "sex",
          placeholder: "请选择性别",
          type: "select",
          options: [
            { label: '男', value: '男' },
            { label: '女', value: '女' },
          ],
        },
        {
          label: "出生年月：",
          keyName: "birthday",
          placeholder: "请选择出生年月",
          type: "date",
        },*/
      ],
      cols: [
        { keyName: "name", label: "姓名" },
        { keyName: "sex", label: "性别" },
        //{ keyName: "age", label: "年龄" },
        { keyName: "tel", label: "联系方式" },
        { keyName: "nation", label: "民族" },
        //{ keyName: "iswork", label: "状态" },
        { keyName: "province", label: "籍贯" },
        { keyName: "edu", label: "学历" },
      ],
      baseParams: ['iswork'],
    };
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      const { iswork } = this.$route.params
      this.formInline.iswork = iswork || 1
      this.page = 1
      this.getList()
      // console.log(iswork)
    },
  },
  methods: {
    unBind(id) {
      const url = `${this.baseUrl}/uplre`;
      const params = {
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg == "success") {
            this.$message({
              type: "success",
              message: "解绑成功!",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: "解绑失败，请稍后再试！",
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "解绑失败，请稍后重试！",
          });
        }
      );
    },
    onReset() {
      console.log("onReset");
      // console.log({...this.formInline})
      const { iswork } = this.$route.params
      const { user_group_id } = this.formInline
      this.formInline = {
        iswork: (iswork || 1),
        page: 1,
        limit: this.limit,
        user_group_id,
        userid: this.user.id,
      };
      this.page = 1;
      this.getList();
    },
    onToggleTab({ index }) {
      this.tabIdx = index;
      switch (index) {
        case '0':
          this.formInline.iswork = 1
          break;
        case '1':
          this.formInline.iswork = 2
          break;
        case '2':
          this.formInline.iswork = 3
          break;
      }
      this.getList();
    },
    getCaptains() {
      this.loading = true
      let url = `fixedpay/getfleet`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ fleet }) => {
        this.loading = false
        this.radioData = fleet.map(v => {
          return {
            label: v.nickname,
            value: v.id,
          }
        })
        this.formInline.fleet = fleet[0].id
        this.$nextTick(() => {
          this.getList()
        })
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    radioChange(v) {
      // console.log(v)
      this.formInline.fleet = v
      this.getList();
    },
  },
  mounted() {
    const { iswork } = this.$route.params
    this.formInline.iswork = iswork
    if (iswork) {
      this.getList()
    }
  },
}

export default minin